export default {
  path: '/pos',
  component: () => import('../../views/pos/pos-router.vue'),
  children: [
    {
      path: '',
      name: 'Pos',
      component: () => import('../../views/pos/pages/Pos.vue'),
      meta: {
        name: 'navigationDrawer.pos',
        icon: '/icons/pos.svg',
        auth: true
      }
    },
    {
      path: 'pos-success',
      name: 'PosSuccess',
      component: () => import('../../views/pos/pages/PosSuccess.vue'),
      meta: {
        name: 'navigationDrawer.pos',
        icon: '/icons/pos.svg',
        auth: true
      }
    },
    {
      path: 'pos-receipt/:id',
      name: 'PosReceipt',
      component: () => import('../../views/pos/pages/PosReceipt.vue'),
      meta: {
        name: 'navigationDrawer.pos',
        icon: '/icons/pos.svg',
        auth: true,
        layout: 'blank'
      }
    }
  ]
}
